
/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'prop-types',
	'./internal/SelectItemListEntry'
], function (
	React,
	PropTypes,
	SelectItemListEntry) {
	class CommonSelectItemsComponent extends React.Component {
		static propTypes = {
			possibleItems: PropTypes.object,
			currentlySelectedItemId: PropTypes.string,
			selectionHandler: PropTypes.func.isRequired,
			onKeyDown: PropTypes.func
		}

		constructor(props) {
			super(props);
			this.state = {
				currentlySelectedItemId: this.props.currentlySelectedItemId
			};
		}
		selectionHandler(id) {

			this.setState({ currentlySelectedItemId: id });
			this.props.selectionHandler(id);

		}

		render() {
			return (
				<div className="content" onKeyDown={this.props.onKeyDown}>
					<SelectItemListEntry
						possibleItems={this.props.possibleItems}
						currentlySelectedItemId={this.state.currentlySelectedItemId}
						selectionHandler={this.selectionHandler.bind(this)}
					/>
				</div>
			);
		}
	}
	return CommonSelectItemsComponent;
});